// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import RestoreUserRequestModel from '../../model/restore-user-request-model';
import RestoreUserRequestDTO from '../dto/restore-user-request-dto';
import dtoSchema from '../schemas/restore-user-request-schema';

export default abstract class RestoreUserRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<RestoreUserRequestDTO>) {
    super();
    if (data) {
      this.id = data.id;
    }
  }
  /**
  * @type {int64}
  */
  id?: number;

  static toModel(dto: DeepPartial<RestoreUserRequestDTO>): RestoreUserRequestModel;
  static toModel(dto: DeepPartial<RestoreUserRequestDTO> | undefined | null): RestoreUserRequestModel | undefined;
  static toModel(dto: DeepPartial<RestoreUserRequestDTO> | undefined | null): RestoreUserRequestModel | undefined {
    return dto ? new RestoreUserRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<RestoreUserRequestModel> | RestoreUserRequestModel): RestoreUserRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
    } as RestoreUserRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for RestoreUserRequestModel, can not map to RestoreUserRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
